import axios from "@/libs/api.request";
// 获取应收报表列表
export const getReceive = params => {
  return axios.request({
    url: "/report/cod/receive",
    method: "get",
    params
  });
};
